<template>
	<div class="person-nav">
		<div class="nav-left">
			<div class="logo-wrap">
				<img id="logo_image" src="https://resources.xycoder.com/dowa/dowa-logo-1.png" alt="DOWA">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Navigation',
};
</script>

<style scoped>
.person-nav {
	z-index: 50;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 50px;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 12px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.nav-left {
	display: flex;
	align-items: center;
	gap: 8px;
}

.logo-wrap {
	display: flex;
	align-items: center;
	text-decoration: none;
}
#logo_image {
	height: 40px;
	width: auto;
	margin-left: 5px;
	margin-top: 0;
	float: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue